import React from "react";
import { BsFillDiamondFill } from "react-icons/bs";

function Timeline(props) {
  return (
    <div className="relative wrap overflow-hidden p-5 md:p-10">
      <div className="border-2-2 absolute left-[5%] border-opacity-20 border-gray-700 h-full border"></div>

      <div className="mb-8 w-full ">
        <div className="order-1 w-5/12 md:w-5/12"></div>
        <div className="z-20 absolute left-[4%] top-[40%] shadow-xl w-8 h-8 ">
          <BsFillDiamondFill size={28} color="white" />
        </div>
        <div className="order-1 bg-[#04091a] text-white shadow-xl w-full md:w-1/2 px-10 py-4">
          <h1 className="mb-3 font-bold text-white font-black text-xl md:text-3xl">
            <span className="text-lg text-transparent bg-clip-text bg-gradient-to-r from-[#d02561] to-[#ff79a8]">
              {props.number}{" "}
            </span>
            {props.title}
          </h1>
          <p className="text-sm leading-snug tracking-wide text-opacity-100">
            {props.details}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Timeline;
